<template>
  <div>
    <v-app-bar flat color="transparent">
      <app-bar-nav-icon />
      <v-toolbar-title class="breadcrumbs d-flex align-center">
        <v-icon class="text-primary">{{ icons.arrowLeft }}</v-icon>
        <router-link
          class="text-decoration--none"
          :to="{ name: 'accommodations.listing' }"
          >Accommodations</router-link
        >
      </v-toolbar-title>
    </v-app-bar>

    <div class="ma-4" v-if="form">
      <div class="display-2 font-weight-bold my-6 text-capitalize">
        Update Accommodation
      </div>

      <!-- Accommodation Form -->
      <div class="col-md-4 col-sm-12 col-xs-12 mt-6 pa-0">
        <v-form ref="form" v-if="form" class="place-form">
          <h3 class="py-5 primary--text">Accommodation Information</h3>

          <label class="text-field-label">Name</label>
          <v-text-field
            flat
            solo
            required
            class="mt-2"
            v-model="form.name"
            :error-messages="form.$getError('name')"
            :loading="loading"
          ></v-text-field>

          <label class="text-field-label">Type</label>
          <v-select
            class="mt-2"
            v-model="form.types"
            :items="accommodationTypes"
            filled
            multiple
            item-text="name"
            item-value="id"
            :error-messages="form.$getError('types')"
          ></v-select>

          <label class="text-field-label">Image</label>
          <v-file-input
            class="mb-2"
            accept="image/*"
            v-model="form.image"
            :error-messages="form.$getError('image')"
          ></v-file-input>

          <label class="text-field-label">Location</label>
          <PlaceAutocomplete
            all
            v-model="form.places_address"
            @select="form.google_places_id = $event"
            :inputError="form.$getError('places_address')"
          />

          <label class="text-field-label">Website</label>
          <v-text-field
            flat
            solo
            required
            class="mt-2"
            v-model="form.website"
            :error-messages="form.$getError('website')"
            :loading="loading"
          ></v-text-field>

          <label class="text-field-label">Phone Number</label>
          <v-text-field
            flat
            solo
            required
            class="mt-2"
            v-model="form.phone_number"
            :error-messages="form.$getError('phone_number')"
            :loading="loading"
          ></v-text-field>

          <label class="text-field-label">Description</label>
          <v-textarea
            class="mt-2"
            v-model="form.description"
            filled
            auto-grow
            :error-messages="form.$getError('description')"
          ></v-textarea>

          <div class="mt-5 d-flex">
            <v-btn
              color="normal"
              class="mr-5 px-6"
              height="40px"
              width="47%"
              :loading="form.$busy"
              :to="{ name: 'accommodations' }"
              >Back</v-btn
            >

            <v-spacer></v-spacer>

            <v-btn
              color="primary"
              class="px-6"
              height="40px"
              width="47%"
              :loading="form.$busy"
              @click="saveAccommodationDetails"
              >Save</v-btn
            >
          </div>
        </v-form>
      </div>
      <!-- End of Accommodation Form -->
    </div>
  </div>
</template>

<script>
import ControlsMixin from '@/utils/mixins/Controls'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import PlaceAutocomplete from '@/components/PlaceAutocomplete'
import { mdiChevronLeft } from '@mdi/js'
import pick from 'lodash/pick'

import Form from '@/utils/form'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'UpdateAccommodation',

  mixins: [ControlsMixin],

  components: {
    AppBarNavIcon,
    PlaceAutocomplete
  },

  data() {
    return {
      icons: {
        arrowLeft: mdiChevronLeft
      },
      form: true
    }
  },

  computed: {
    ...mapState({
      accommodation: state => state.accommodation.accommodationDetails,
      accommodationTypes: state => state.options.accommodation_types
    })
  },

  created() {
    this.getAccommodationTypes()
    this.form = new Form(this.accommodation)
    this.getAccommodation()
  },

  methods: {
    ...mapActions({
      updateAccommodation: 'accommodation/updateAccommodation',
      getAccommodationDetails: 'accommodation/getAccommodationDetails',
      getAccommodationTypes: 'options/getAccommodationTypes',
      setAlert: 'alert/setAlert'
    }),

    async getAccommodation() {
      this.loading = true
      await this.getAccommodationDetails(this.$route.params.id)
      this.form.google_places_id = null
      this.form = new Form(
        pick(this.accommodation, [
          'id',
          'name',
          'description',
          'website',
          'image',
          'types',
          'phone_number',
          'google_places_id',
          'places_address'
        ])
      )
      this.form.types = this.accommodation.typeList
      this.loading = false
    },

    async saveAccommodationDetails() {
      this.form.$busy = true
      this.form.$clearErrors()

      const data = this.form.$formData(['image'])
      data.append('_method', 'PUT')

      if (this.form.image && this.form.image instanceof File) {
        data.append('image', this.form.image)
      }

      this.updateAccommodation(data)
        .then(() => {
          this.form.$busy = false
          this.setAlert({
            message: 'Accommodation details successfully updated!',
            color: 'success'
          })
          this.$router.replace({ name: 'accommodations.listing' })
        })
        .catch(err => {
          this.form.$busy = false
          if (err.response.status === 422) {
            this.form.$setErrors(err.response.data.errors)
          }
        })
    }
  }
}
</script>
